import type { Feature, FeatureCollection } from "geojson";

export type GeoJSONData = Feature | FeatureCollection;
